import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Col, Row,
    ModalHeader, ModalBody, ModalFooter, Button, ButtonGroup, Card, CardBody, Badge
} from 'reactstrap';
import classnames from 'classnames';
import './CaseSections.scss';
import { SYSTEMDEFINED, RECALCULATE, SAVE, DATA,VIDEO_KYC, PREDEFINED, FINANCIAL, SUBMITTED, REJECTED, INTERNATIONAL } from '../../constants';
import {
    sectionDetails, sectionDetailsUpload, hasCompleted, isPredefined, isAssigned,
    activeTab, isSystemDefined, changeOrder, isApproved, isRejected,
    commentReadCountRequestBody, isInternational, isDataSection, isFinancialSection, isVideoKYC
} from './Helper';
import PdfView from '../../../../components/ReusableComponents/SurveyView/index';
import CasesSectionModal from '../../../../components/ReusableComponents/ModalComponent/CasesModal/index';
// import TemplateDropdown from '../TemplateDropdown';
// import { approveStatus, rejectStatus, toggleTab, toggleModal, addTabs, toggleDropdown } from '../../List/Actions'
import Modal from '../../../../components/UI/Modal/Modal';
import fileSaver from 'file-saver';
import { Preloading } from '../../../../components/UI/Preloader/action';
import { toast } from 'react-toastify';
import * as sectionAction from '../action';
import CaseScorecardEdit from '../CaseScorecardScore/index';
import AddSectionTab from '../AddSectionsTab/index'
import CorporateModal from '../../../../components/UI/CorporateModal'
import { MODAL_TYPE_FORM } from '../../../../constants'
import AssignToCorrespondent from '../Assign'
import CommentSection from '../../../../components/ReusableComponents/Comments';
import { commentReadStatus } from '../../../../components/Services/action';
import SectionRearrange from '../SectionRearrange/index';

import { VIDEO_KYC_APP } from '../../../../config';
import AutomatedRevenueForm from '../EditSection/AutomatedRevenueForm/index'
import CreditLimitEditSection from '../EditSection/CreditLimitEditSection/index'
import {fetchCalculationParameterRequest,fetchCalculateRevenueRequest} from '../EditSection/AutomatedRevenueForm/action'
import {getCreditLimitModelAtSectionData, recalculatecreditLimitAtSection ,saveCreditLimitModelAtSection} from '../EditSection/CreditLimitEditSection/action'
import {fetchBenchmarkCalculationParameterRequest, fetchCalculateBenchmarkRequest} from '../EditSection/AutomatedBenchmarkForm/action'
import AutomatedBenchmarkForm from '../EditSection/AutomatedBenchmarkForm';
const EXECUTIVE_SUMMARY = ['executiveSummaryInternational','executiveSummaryDomestic'];
const ESTIMATED_REVENUE_RANGE = ['estimatedRevenueRange'];
const FERRERO_KPI = ['ferrerokpi'];
const SCORECARD_RATIONAL = ['ScorecardRationale'];
const BENCHMARK_RATIOS = ['benchmarkRatio'];
const CREDIT_LIMIT=['CreditLimit']
const SCORE_BREAK_UP = ['ScoreBreakUp','ScoreBreakUpAdani','ScoreBreakUpBundleCorp','ScoreBreakUpBundleNonCorp','ScoreBreakUpHitachi','ScoreBreakUpForCorp','ScoreBreakUpForNonCorp'];
const PHOTOGRAPH_TEMPLATE=['Photograph']
const SCORE_SUMMARY = ['ScoreSummary']
class ViewSections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            predefinedSectionDeleteList:[],
            dataSectionDeleteList:[],
            multipleSectionDeleteList:{},
            showDeleteButton:false,
            pdfFile: null,
            pdf: null,
            pdfUrl: null,
            tabData: null,
            tabs: null,
            tabContentl: null,
            downloadUrl: null,
            noPdfMessage: '',
            showModal: false,
            showSectionEditModal: false,
            showCreditLimitEditModel:false,
            showImageUploadModel:false,
            body: null,
            predefinedList: [],
            dataSectionList: [],
            modalClass: '',
            editCaseScorecardButton: null,
            editSectionButton:null,
            downloadAction: null,
            imageUploadButton:null,
            uploadAction: null,
            modalType: "",
            modalTitle: '',
            showCorporateModal: false,
            modalCloseHandler: this.toggleCorporateModal,
            corporateModalBody: null,
            textInput: "",
            closeFlag: false,
            readstatus: 0,
        };
    }
    componentDidMount() {
    }

    handleMeet = () =>{
        // let sections = this.props.sections.data;
        let caseDetails = this.props.caseData;
        let caseId = caseDetails.data.caseId;
        let counterpartyId = caseDetails.data.counterpartyId;
        let counterpartyName = caseDetails.data.counterpartyName;
        let corporateName = caseDetails.data.corporateName;
        let contact = caseDetails.data.counterpartyPhone;
        let address = caseDetails.data.counterpartyAddress;//counterpartyAddress


        let url = `${VIDEO_KYC_APP}`+'?externalId='+caseId+'&contact='+contact+'&participantId='+counterpartyId+'&participantName='+counterpartyName.replace('&', '%26')+'&address='+address.replace('&', '%26')+"&companyName="+corporateName.replace('&', '%26');
        window.open(url, '_blank');
    }

    handleReview = () => {
        let caseDetails = this.props.caseData;
        let caseId = caseDetails.data.caseId;
        let agentId = caseDetails.data.userId;
  
        let url = `${VIDEO_KYC_APP}`+'/review'+'?externalId='+caseId+'&userId='+agentId;
        window.open(url, '_blank');
    }

    handleFileEvent=(e)=>{
        this.props.preloading(true);
        const chosenFiles = Array.prototype.slice.call(e.target.files)  
        const { caseData } = this.props;
        const { tabData } = this.state;
        const requestUpload= sectionDetailsUpload(tabData,caseData,chosenFiles,tabData.sectionType)
        this.props.uploadMultipleImages(requestUpload,this.props.caseData.data.computedReportId)
        e.preventDefault();
    }

    handleToggle = (e, sectionNo) => {
        const sectionDetail = sectionDetails(this.props.sections.data, sectionNo);
        this.setState({
            tabData: sectionDetail,
            // pdfFile: null
        }, () => {
            if (this.state.tabData.sectionType === SYSTEMDEFINED) {
                if (this.state.tabData.surveyPdfFile) {
                    this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
                }
                this.setState({
                    
                    editCaseScorecardButton:
                        <Button outline color="primary" title="Edit Scorecard" onClick={this.handleEdit} id="editCaseScorecard" disabled={hasCompleted(this.props.caseData)}>
                            <i className="fa fa-edit"></i>
                        </Button>,
                    downloadAction: null,
                    uploadAction: null,
                    editSectionButton: null
                })
            } else {
                this.setState({
                    downloadAction: (this.state.tabData.sectionType !== INTERNATIONAL) ?
                        <Button outline color="primary" title="Download Section Excel" onClick={this.handleDownload}>
                            <i className="fa fa-download"></i>
                        </Button> : '',
                    uploadAction:
                        <div className={hasCompleted(this.props.caseData) ? "btn btn-primary position-relative upload-action disabled" : "btn btn-primary position-relative upload-action"} title="Upload Section Excel" disabled={hasCompleted(this.props.caseData)}>
                            <input onChange={this.handleUpload} type="file" name="file" id="file" className="upload-file" title="Upload Section Excel" disabled={hasCompleted(this.props.caseData)} />
                            <i className="fa fa-upload"></i>
                        </div>,
                    editCaseScorecardButton: null,
                    editSectionButton: (this.state.tabData.sectionTags !== null && (ESTIMATED_REVENUE_RANGE.includes(this.state.tabData.sectionTags[0]) || BENCHMARK_RATIOS.includes(this.state.tabData.sectionTags[0]) || SCORE_BREAK_UP.includes(this.state.tabData.sectionTags[0]) || SCORE_SUMMARY.includes(this.state.tabData.sectionTags[0]) || CREDIT_LIMIT.includes(this.state.tabData.sectionTags[0]))) ?
                        <Button outline color="primary" title="Edit Section" onClick={this.handleSectionEditToggle} id="editSection" disabled={hasCompleted(this.props.caseData)}>
                            <i className="fa fa-edit"></i>
                        </Button> :null,
                    imageUploadButton:(this.state.tabData.sectionTags !== null &&(PHOTOGRAPH_TEMPLATE.includes(this.state.tabData.sectionTags[0].split('_')[0]))) ?
                    <div  title="Upload Section Images" className="btn btn-primary position-relative upload-action">
                            <input type="file" name="file" id="fileUpload" className="upload-file" title="Upload Section Images" multiple accept='image/jpg, image/png, image/jpeg' onChange={(e)=>{this.handleFileEvent(e)}}/>
                            <i className="fa fa-file-image-o" ></i>&nbsp;<i className="fa fa-upload"></i>
                        </div>:''})
            }
            if (this.state.tabData.surveyPdfFile) {
                this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
            }

            this.updateTabContent([this.state.tabData]);
            this.props.setActiveTab(this.state.tabData);

            this.props.commentReadStatus(commentReadCountRequestBody(this.state.tabData.taskId))
        })
    }
    
    handleCreditLimitSectionToggle=()=>{
        this.setState(prevState => ({
            showCreditLimitEditModel: false,
        }))
        
    }

    handleSectionEditToggle = () => {
        let caseDetails = this.props.caseData;
        let caseId = caseDetails.data.caseId;
        if(CREDIT_LIMIT.includes(this.state.tabData.sectionTags[0]) && caseDetails.data.computedReportId !== undefined){
            this.props.getCreditLimitModelAtSectionData(caseDetails.data.computedReportId)
            this.props.preloading(true)
            this.setState({
                showCreditLimitEditModel: false,
            })
        }else if (ESTIMATED_REVENUE_RANGE.includes(this.state.tabData.sectionTags[0]) && caseId !== undefined) {
            this.setState(prevState => ({
                showSectionEditModal: !prevState.showSectionEditModal
            }))
            this.props.fetchCalculationParameterRequest(caseId);
        } else if (BENCHMARK_RATIOS.includes(this.state.tabData.sectionTags[0]) && caseId !== undefined) {
            this.setState(prevState => ({
                showBenchmarkModal: !prevState.showBenchmarkModal
            }))
            this.props.fetchBenchmarkCalculationParameterRequest(caseId);
        }else if(SCORE_BREAK_UP.includes(this.state.tabData.sectionTags[0]) && caseDetails.data.computedReportId !== undefined){
            this.props.preloading(true);
            this.props.fetchScoreBreakUpDetails(this.props.caseData.data.computedReportId,this.state.tabData.sectionTags[0]);
        }else if(SCORE_SUMMARY.includes(this.state.tabData.sectionTags[0]) && caseDetails.data.computedReportId !== undefined){
            this.props.preloading(true);
            this.props.fetchScoreSummaryDetails(this.props.caseData.data.computedReportId,this.state.tabData.computedSectionId);
        }
    }
    createRevenuRequestBody = (formData) => {
        this.props.preloading(true);
        let caseDetails = this.props.caseData;
        let caseId = caseDetails.data.caseId;
        this.props.fetchCalculateRevenueRequest(caseId, formData);
        this.handleSectionEditToggle();
    }
    createBencmarkRequestBody = (formData) => {
        this.props.preloading(true);
        let caseDetails = this.props.caseData;
        let caseId = caseDetails.data.caseId;
        this.props.fetchCalculateBenchmarkRequest(caseId, formData);
        this.handleSectionEditToggle();
    }
    handleCheckbox = (e, sectionNo) => {
        if(e.sectionType=="PREDEFINED" ||e.sectionType=="INTERNATIONAL" || !e.sectionType){
            const predefinedIndex=this.state.predefinedSectionDeleteList.indexOf(sectionNo)
            if(predefinedIndex==-1){
                this.state.predefinedSectionDeleteList.push(sectionNo)
            }
            else{
                    this.state.predefinedSectionDeleteList.splice(predefinedIndex, 1); 
            }
            }
          else{
                const DataIndex=this.state.dataSectionDeleteList.indexOf(sectionNo)
                if(DataIndex==-1){
                    this.state.dataSectionDeleteList.push(sectionNo)
                }
                else{
                        this.state.dataSectionDeleteList.splice(DataIndex, 1);    
                }
               
                }
                this.showbuttondelete()
            }

        showbuttondelete= () =>{
            if(this.state.predefinedSectionDeleteList.length>0 || this.state.dataSectionDeleteList.length>0 )
            { this.setState({showDeleteButton:true}) }
            else{this.setState({showDeleteButton:false})}
        }
        
       
    handleApprove = () => {
        this.handleModalToggle()
        this.setState({
            body: <div>
                <p>Are you sure you want to Approve this section?</p>
                <Button className="btn mt-3" color="primary" onClick={this.handleApproveSection}>Approve</Button>
                <Button className="btn mt-3 ml-3" color="danger" onClick={this.onCancel} >Cancel</Button>
            </div>,
        })

    }
    handleApproveSection = () => {
        this.props.approveSection(this.state.tabData.taskId, this.props.caseData.data.computedReportId)
        this.handleModalToggle()
        this.props.preloading(true)
    }

    handleReject = () => {
        this.handleModalToggle()
        this.setState({
            body: <div>
                <strong>Are you sure you want to reject this section?</strong>
                <textarea rows="4" cols="50" className="mt-3" name="comment" form="usrform" placeholder="why you want to reject?" onChange={this.handleTextArea} />
                <br />
                <Button className="btn mt-5" color="primary" onClick={this.handleRejectSection} disabled={this.state.disable}>Reject</Button>
                <Button className="btn mt-5 ml-3" color="danger" onClick={this.onCancel} >Cancel</Button>
            </div>,
        })
    }

    handleRejectSection = () => {
        if (this.state.textInput.length > 0) {
            let reqBody = {
                type: REJECTED,
                comment: this.state.textInput
            }
            this.props.rejectSection(this.state.tabData.taskId, this.props.caseData.data.computedReportId, reqBody)

            this.setState({
                warning: ""
            }, () => this.handleModalToggle(), this.props.preloading(true))
        }
        else {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Add comments to reject
                </div>
            );
        }

    }

    handleTextArea = (event) => {
        this.setState({
            textInput: event.target.value
        })
    }
    handleAdd = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            corporateModalBody:
                <AddSectionTab
                    selectedPredefined={this.predefinedSelected}
                    selectedDatasections={this.dataSections}
                    computedReportId={this.props.caseData.data.computedReportId}
                    toggleCorporateModal={this.toggleCorporateModal} />,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Choose Sections To Add',
        }))
    }

    onCancel = () => {
        this.handleModalToggle()
    }

    toggleCorporateModal = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            corporateModalBody: null
        }));
    }

    handleModalToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            warning: ""
        }))
    }
    refreshPage = () => {
        window.location.reload();
    }

    handleCaseScorecardModalToggle = (data, type) => {
        if (type === RECALCULATE) {
            this.props.recalculateScore(data);
        } else if (type === SAVE) {
            this.props.saveCaseScorecard(data);
        } else {
            this.setState(prevState => ({
                showModal: !prevState.showModal
            }))

        }
    }
    caseScorecardDetailsModal = (caseScorecardDetails, caseScorecardEditError) => {
        this.setState({
            body: <CaseScorecardEdit modalCallback={this.handleCaseScorecardModalToggle}
                caseScorecardError={caseScorecardEditError} caseScorecardUpdatedData={caseScorecardDetails}
                updateModalData={this.updateModalData} />,
            modalClass: 'Large-Modal'
        })
    }
    updateModalData = (modalData) => {
        this.caseScorecardDetailsModal(modalData, [])
    }
    componentDidUpdate(prevProps) {
        const { addedPredefSections, uploadPredefinedModal, caseScorecardDetails, deletedPredefinedSectionData,deletedMultipleSectionData,
            caseScorecardDetailsError, downloadUrl, sectionPdfFile, uploadModal, uploadModalError, sections,
            recalculatedScore, caseScorecardRecalculateError, caseScorecardEdit, caseScorecardEditError, addedDataSections, deletedDataSection,
            assigned, taskStatus, readCommentStatus,systemDefineSectionFailureStatus,systemDefineSectionSuccessStatus,caseScorecardRationalDetailssStatus,caseScorecardRationalDetailsErrorStatus, ferreroKpiDetails,revenuCalculationParams,creditLimitModelParams ,revenuCalculationResponse, 
            benchmarkCalculationResponse,recalculatedValues,initialValues,uploadImageResponse,uploadImageResponseError,scoreBreakUpDetailsStatus,scoreBreakUpDetailsErrorStatus,scoreSummaryDetailsStatus,scoreSummaryDetailsErrorStatus } = this.props

        if (readCommentStatus !== prevProps.readCommentStatus) {
            let readCount = Object.values(readCommentStatus.newCommentCountMap)
            this.setState({
                readstatus: readCount[0]
            })
        }

        if(initialValues !== prevProps.initialValues){
            this.props.preloading(false)
            this.setState({
                showCreditLimitEditModel: true,
            })
        }

         if(recalculatedValues !== prevProps.recalculatedValues){
             this.props.preloading(false)
             this.setState({
                 showCreditLimitEditModel: true,
             })
         }

         if (uploadImageResponse !== prevProps.uploadImageResponse) {
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;File Uploaded Successfully!
                </div>
            );
        } else if (uploadImageResponseError !== prevProps.uploadImageResponseError) {
            console.log('ERROR>>', JSON.stringify(uploadImageResponseError));
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >{(uploadImageResponseError.response && uploadImageResponseError.response.data) ? uploadImageResponseError.response.data.message : "Something went wrong! Please try again."}</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        } 

        if (uploadModal !== prevProps.uploadModal) {
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;File Uploaded Successfully!
                </div>
            );
        } else if (uploadModalError !== prevProps.uploadModalError) {
            console.log('ERROR>>', JSON.stringify(uploadModalError));
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >{(uploadModalError.response && uploadModalError.response.data) ? uploadModalError.response.data.message : "Something went wrong! Please try again."}</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if (addedPredefSections.error !== prevProps.addedPredefSections.error) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >Predefined section(s) couldn&#39;t be added.</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        else if (!addedPredefSections.error && addedPredefSections !== prevProps.addedPredefSections) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Predefined section(s) successfully added
                </div>
            );
        }
        if (addedDataSections.error !== prevProps.addedDataSections.error) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >Cannot Add Data Section(s)! {(addedDataSections.error.response && addedDataSections.error.response.data) ? addedDataSections.error.response.data.message : "Something went wrong! Please try again."}</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        else if (!addedDataSections.error && addedDataSections !== prevProps.addedDataSections) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Data section(s) successfully added
                </div>
            );
        }
        if (!uploadPredefinedModal.error && uploadPredefinedModal !== prevProps.uploadPredefinedModal) {
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Predefined Section Uploaded!
                </div>
            );
        }
        else if (uploadPredefinedModal.error && uploadPredefinedModal !== prevProps.uploadPredefinedModal) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Predefined Section Uploading Failed</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if (!ferreroKpiDetails.error && ferreroKpiDetails !== prevProps.ferreroKpiDetails) {
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Ferrero KPI Uploaded!
                </div>
            );
            this.props.preloading(false);
        }
        else if (ferreroKpiDetails.error && ferreroKpiDetails !== prevProps.ferreroKpiDetails) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Ferrero KPI Uploading Failed</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }

        if (!deletedPredefinedSectionData.error && deletedPredefinedSectionData !== prevProps.deletedPredefinedSectionData) {
            //this.handleModalToggle();
            this.setState({
                tabContent: null,
                pdfFile: null
            });
            this.props.setActiveTab([]);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Section successfully deleted
                </div>
            );
        }
        else if (deletedPredefinedSectionData.error && deletedPredefinedSectionData !== prevProps.deletedPredefinedSectionData) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >{(deletedPredefinedSectionData.error.response && deletedPredefinedSectionData.error.response.data) ? deletedPredefinedSectionData.error.response.data.message : "Something went wrong! Please try again."}</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if (!deletedMultipleSectionData.error && deletedMultipleSectionData !== prevProps.deletedMultipleSectionData) {
            //this.handleModalToggle();
            this.state.dataSectionDeleteList.splice(0,this.state.dataSectionDeleteList.length)
            this.state.predefinedSectionDeleteList.splice(0,this.state.predefinedSectionDeleteList.length)
            this.showbuttondelete()
            this.setState({
                tabContent: null,
                pdfFile: null
            });
            this.props.setActiveTab([]);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;All selected Sections successfully deleted
                </div>
            );
        }
        else if (deletedMultipleSectionData.error && deletedMultipleSectionData !== prevProps.deletedMultipleSectionData) {
            this.state.dataSectionDeleteList.splice(0,this.state.dataSectionDeleteList.length)
            this.state.predefinedSectionDeleteList.splice(0,this.state.predefinedSectionDeleteList.length)
            this.showbuttondelete()
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5>Error</h5>
                    <h5 className="mt-5 text-danger" >{(deletedPredefinedSectionData.error.response && deletedPredefinedSectionData.error.response.data) ? deletedPredefinedSectionData.error.response.data.message : "Something went wrong! Please try again."}</h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }

        if (!deletedDataSection.error && deletedDataSection !== prevProps.deletedDataSection) {
            this.setState({
                tabContent: null,
                pdfFile: null
            });
            this.props.setActiveTab([]);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Section successfully deleted
                </div>
            );
        }
        else if (deletedDataSection.error && deletedDataSection !== prevProps.deletedDataSection) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h4><i className="fa fa-exclamation-triangle text-danger"></i>Error</h4>
                    <h5 className="mt-5 text-danger" ><strong>{(deletedDataSection.error.response && deletedDataSection.error.response.data) ? deletedDataSection.error.response.data.message : "Something went wrong! Please try again."}</strong></h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if (!assigned.error && assigned !== prevProps.assigned) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-check-circle text-success"></i>Success</h5>
                    <h5 className="mt-5 text-success" ><strong>Section successfully assigned to a correspondent</strong></h5>
                    <button className="btn btn-success mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            })
        }
        else if (assigned.error && assigned !== prevProps.assigned) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h4><i className="fa fa-exclamation-triangle text-danger"></i>Error</h4>
                    <h5 className="mt-5 text-danger" ><strong>Section couldn&#39;t be assigned! {(assigned.error.response && assigned.error.response.data) ? assigned.error.response.data.message : "Something went wrong! Please try again."}</strong></h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            })
        }
        if (!taskStatus.error && taskStatus !== prevProps.taskStatus) {
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-check-circle text-success"></i>Success</h5>
                    <h5 className="mt-5 text-success" ><strong>{taskStatus.message}</strong></h5>
                    <button className="btn btn-success mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            })
        }
        else if (taskStatus.error && taskStatus !== prevProps.taskStatus) {
            this.handleModalToggle();
            this.props.preloading(false)
            this.setState({
                body: <div>
                    <h4><i className="fa fa-exclamation-triangle text-danger"></i>Error</h4>
                    <h5 className="mt-5 text-danger" ><strong>{(taskStatus.error.response && taskStatus.error.response.data) ? taskStatus.error.response.data.message : "Something went wrong! Please try again."}</strong></h5>
                    <button className="btn btn-danger mt-5" onClick={this.handleModalToggle}>OK</button>
                </div>
            })
        }

        if (caseScorecardDetails !== prevProps.caseScorecardDetails) {
            this.setState(prevState => ({ showModal: !prevState.showModal }))
            this.caseScorecardDetailsModal(caseScorecardDetails, '');
            this.props.preloading(false);
        } else if (caseScorecardDetailsError !== prevProps.caseScorecardDetailsError) {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Error</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{(caseScorecardDetailsError.response && caseScorecardDetailsError.response.data) ? caseScorecardDetailsError.response.data.message : "Something went wrong! Please try again."}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </div>
            }))
            this.props.preloading(false);
        }
        if(systemDefineSectionSuccessStatus !== prevProps.systemDefineSectionSuccessStatus){
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Section Updated Successfully....!
                </div>
            );
            this.props.getAllSections(this.props.caseData.data.computedReportId)
        }else if(systemDefineSectionFailureStatus !== prevProps.systemDefineSectionFailureStatus){
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Failed to Generate Executive Summary </h5>
                    <button className="btn btn-danger mt-5" onClick={this.refreshPage}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }

        if(caseScorecardRationalDetailssStatus !== prevProps.caseScorecardRationalDetailssStatus){
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;ScorecardRational Updated Successfully....! 
                </div>
            );
            window.location.reload()
            this.props.getAllSections(this.props.caseData.data.computedReportId)
        }else if(caseScorecardRationalDetailsErrorStatus !== prevProps.caseScorecardRationalDetailsErrorStatus){
            this.props.preloading(false);
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Failed to Generate ScorecardRational </h5>
                    <button className="btn btn-danger mt-5" onClick={this.refreshPage}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if(scoreBreakUpDetailsStatus !== prevProps.scoreBreakUpDetailsStatus){
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;ScoreBreakUp Updated Successfully....! 
                </div>
            );
           window.location.reload()
        }else if(scoreBreakUpDetailsErrorStatus !== prevProps.scoreBreakUpDetailsErrorStatus){
            this.props.preloading(false);
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Failed to Generate ScoreBreakUp </h5>
                    <button className="btn btn-danger mt-5" onClick={this.refreshPage}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }
        if(scoreSummaryDetailsStatus !== prevProps.scoreSummaryDetailsStatus){
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Score Summary Updated Successfully....! 
                </div>
            );
           window.location.reload()
        }else if(scoreSummaryDetailsErrorStatus !== prevProps.scoreSummaryDetailsErrorStatus){
            this.props.preloading(false);
            this.handleModalToggle();
            this.setState({
                body: <div>
                    <h5><i className="fa fa-exclamation-triangle"></i>&nbsp;Error</h5>
                    <h5 className="mt-5 text-danger" >Failed to Generate Score Summary </h5>
                    <button className="btn btn-danger mt-5" onClick={this.refreshPage}>OK</button>
                </div>
            });
            this.props.preloading(false);
        }

        if (sectionPdfFile !== prevProps.sectionPdfFile) {
            const temp = {
                sectionData: this.state.tabData,
                pdfUrl: this.props.sectionPdfFile.data
            }
            if (temp.pdfUrl) {
                this.setState({
                    pdfFile: <PdfView {...temp} />
                })
            } else {
                this.setState({
                    noPdfMessage: null
                })
            }
        }
        if (sections !== prevProps.sections) {
            // this.props.commentReadStatus()
            if (sections.data.length > 0) {
                if (this.props.activeTab.length === 0) {
                    let active = activeTab(sections)
                    this.props.setActiveTab(active)
                    this.setState({
                        tabData: active,
                    }, () => {
                        this.checkTabType();
                        this.updateTabContent([active]);
                        this.props.commentReadStatus(commentReadCountRequestBody(active.taskId));
                        if (this.state.tabData.surveyPdfFile) {
                            this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
                        }
                    })
                } else {
                    sections.data.forEach((item, index, element) => {
                        if (this.state.tabData.sectionTemplateId === item.sectionTemplateId) {
                            this.props.setActiveTab(item);
                            this.setState(prevState => ({
                                tabData: item
                            }), () => {
                                this.checkTabType();
                                this.updateTabContent([item]);
                                if (this.state.tabData.surveyPdfFile) {
                                    this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
                                }
                            })

                        }
                    })

                }
            }

            this.props.preloading(false);
        }
        if (recalculatedScore !== prevProps.recalculatedScore) {
            this.props.preloading(false)
            caseScorecardDetails.score = recalculatedScore.score;
            caseScorecardDetails.riskGrade = recalculatedScore.riskGrade
            this.caseScorecardDetailsModal(caseScorecardDetails, caseScorecardEditError);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Score updated successfully
                </div>
            );
        }
        if (caseScorecardRecalculateError !== prevProps.caseScorecardRecalculateError) {
            this.caseScorecardDetailsModal(caseScorecardDetails, (caseScorecardRecalculateError.response && caseScorecardRecalculateError.response.data) ? caseScorecardRecalculateError.response.data.message : "Something went wrong! Please try again.")
        }
        if (caseScorecardEdit !== prevProps.caseScorecardEdit) {
            /* this.setState(prevState => ({
                showModal: !prevState.showModal,
            })); */
            this.props.getAllSections(this.props.caseData.data.computedReportId)
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Scorecard updated successfully
                </div>
            );
        } else if (caseScorecardEditError !== prevProps.caseScorecardEditError) {
            this.props.preloading(false);
            this.caseScorecardDetailsModal(caseScorecardDetails, caseScorecardEditError);
        }
        if (downloadUrl !== prevProps.downloadUrl) {
            if (this.state.tabData.sectionType === DATA || this.state.tabData.sectionType === VIDEO_KYC) {
                if (this.state.tabData.taskStatus === SUBMITTED) {
                    window.open(this.props.downloadUrl.data, `${this.state.tabData.displayName}_Template.xlsx`);
                }
                else if (this.state.tabData.surveyResponseId) {
                    let blob = new Blob([this.props.downloadUrl], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                    fileSaver.saveAs(blob, `${this.state.tabData.displayName}.xlsx`);
                } else {
                    window.open(this.props.downloadUrl.data, `${this.state.tabData.displayName}_Template.xlsx`);
                }
            } else if (this.state.tabData.sectionType === FINANCIAL) {
                let blob = new Blob([this.props.downloadUrl], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                if (this.state.tabData.taskStatus === SUBMITTED) {
                    window.open(this.props.downloadUrl.data, `${this.state.tabData.displayName}_Template.xlsx`);
                }
                else if (this.state.tabData.surveyResponseId) {
                    fileSaver.saveAs(blob, `${this.state.tabData.displayName}.xlsx`);
                } else {
                    fileSaver.saveAs(blob, `${this.state.tabData.displayName}_Template.xlsx`);
                }

            } else {
                window.open(this.props.downloadUrl.data, `${this.state.tabData.displayName}_Template.xlsx`)
            }
            this.props.preloading(false)
        }
        if(revenuCalculationResponse != prevProps.revenuCalculationResponse){
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Calculation Completed.
                </div>
            );
            this.props.preloading(false)
        }
        if(benchmarkCalculationResponse != prevProps.benchmarkCalculationResponse){
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Benchmark Calculation Completed.
                </div>
            );
            this.props.preloading(false)
        }
    }
    componentWillUnmount() {
        this.props.setActiveTab([]);
    }

    handleUploadMultipleImages =  (e) => {
        e.preventDefault();
        this.setState({
            showImageUploadModel:true
        })     
    }

    checkTabType = () => {
        // isSystemDefined(this.state.tabData)
        if (isSystemDefined(this.state.tabData)) {
            if (this.state.tabData.surveyPdfFile) {
                this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
            }
            this.setState({
                downloadAction: null,
                uploadAction: null,
                editCaseScorecardButton:
                    <Button outline color="primary" title="Edit Scorecard" onClick={this.handleEdit} id="editCaseScorecard" disabled={hasCompleted(this.props.caseData)}>
                        <i className="fa fa-edit"></i>
                    </Button>,
                editSectionButton: null
            })
        } else {
            this.setState({
                downloadAction: (this.state.tabData.sectionType !== INTERNATIONAL) ?
                    <Button outline color="primary" title="Download Section Excel" onClick={this.handleDownload} > {/* disabled={hasCompleted(this.props.caseData)} */}
                        <i className="fa fa-download"></i>
                    </Button> : '',
                uploadAction:
                    <div className={hasCompleted(this.props.caseData) ? "btn btn-primary position-relative upload-action disabled" : "btn btn-primary position-relative upload-action"} title="Upload Section Excel">
                        <input onChange={this.handleUpload} type="file" name="file" id="file" className="upload-file" title="Upload Section Excel" disabled={hasCompleted(this.props.caseData)} />
                        <i className="fa fa-upload"></i>
                    </div>,
                editSectionButton: (this.state.tabData.sectionTags !== null && (ESTIMATED_REVENUE_RANGE.includes(this.state.tabData.sectionTags[0]) || SCORE_BREAK_UP.includes(this.state.tabData.sectionTags[0]) || SCORE_SUMMARY.includes(this.state.tabData.sectionTags[0]) || CREDIT_LIMIT.includes(this.state.tabData.sectionTags[0]))) ?
                <Button outline color="primary" title="Edit Section" onClick={this.handleSectionEditToggle} id="editSection" disabled={hasCompleted(this.props.caseData)}>
                        <i className="fa fa-edit"></i>
                    </Button> : null,
                imageUploadButton:(this.state.tabData.sectionTags !== null &&( PHOTOGRAPH_TEMPLATE.includes(this.state.tabData.sectionTags[0].split('_')[0]))) ?
                <div  title="Upload Section Images" className="btn btn-primary position-relative upload-action">
                            <input type="file" name="file" id="fileUpload" className="upload-file" title="Upload Section Images" multiple accept='image/jpg, image/png, image/jpeg' onChange={(e)=>{this.handleFileEvent(e)}}/>
                            <i className="fa fa-file-image-o" ></i>&nbsp;<i className="fa fa-upload"></i>
                        </div>:''})
        }
        if (!this.state.tabData.surveyExternalId) {
            this.setState({
                downloadUrl: this.state.tabData.sectionTemplateExternalId
            })
        } else {
            this.setState({
                downloadUrl: this.state.tabData.surveyExternalId
            }, () => {
                this.props.showSectionPdf(this.state.tabData.surveyPdfFile);
            })
        }

    }
    handleModalSuccess = () => {
        this.handleModalToggle()
        this.props.setActiveTab(this.state.tabData)
        if (this.state.tabData.surveyPdfFile) {
            this.props.showSectionPdf(this.state.tabData.surveyPdfFile)
        }
    }


    close = () => {
        this.setState(prevState => ({ showModal: !prevState.showModal }));
    }
    updateTabContent = (data) => {
        let temp = {
            sectionData: data[0],
            pdfUrl: null
        };
        if (data[0].surveyPdfFile === null) {
            if (data[0].sectionType === DATA || data[0].sectionType === FINANCIAL || data[0].sectionType === INTERNATIONAL) {
                this.setState({
                    noPdfMessage: <span className="no-pdf-message"><i className="fa fa-exclamation-circle"></i>&nbsp;Survey Response Not present</span>,
                    pdfFile: null
                })
            } else if (data[0].sectionType === PREDEFINED || data[0].sectionType === SYSTEMDEFINED) {
                this.setState({
                    noPdfMessage: <span className="no-pdf-message"><i className="fa fa-exclamation-circle"></i>&nbsp;{(data[0].sectionType === SYSTEMDEFINED) ? 'System Defined' : 'Predefined'} Section Not Edited</span>,
                    pdfFile: null
                })
            }
        } else {
            this.setState({
                noPdfMessage: null,
                pdfFile: <PdfView {...temp} />
            })
        }
        this.setState({
            tabContent: data.map(p => {
                return (
                    <TabPane key={p.order}  /* tabId={p.subcaseNo} */>
                        <Row>
                            <Col>
                                <strong>Section Name: </strong>{p.sectionTemplateName}
                            </Col>
                        </Row>
                    </TabPane>
                )

            })
        })
    }
    handleDownload = () => {
        this.props.preloading(true);
        if (this.state.tabData.sectionType === DATA || this.state.tabData.sectionType === VIDEO_KYC) {
            if (this.state.tabData.taskStatus === SUBMITTED) {
                this.props.downloadSubmittedTask(this.state.tabData.surveyExternalId)
            }
            else if (this.state.tabData.surveyResponseId) {
                this.props.setDataSurveyDownloadLink(this.state.tabData.surveyResponseId)
            } 
            else {
                this.props.setSectionDownloadLink(this.state.tabData.sectionTemplateExternalId)
            }
        } else if (this.state.tabData.sectionType === FINANCIAL) {
            if (this.state.tabData.taskStatus === SUBMITTED) {
                this.props.downloadSubmittedTask(this.state.tabData.surveyExternalId)
            }
            else if (this.state.tabData.surveyResponseId) {
                this.props.setDataSurveyDownloadLink(this.state.tabData.surveyResponseId)
            } else {
                this.props.setFinancialSurveyDownloadLink(this.state.tabData.sectionTemplateExternalId)
            }
        } else if (this.state.tabData.sectionType === PREDEFINED) {
            if (this.state.tabData.surveyExternalId) {
                this.props.setpredefinedSectionDownloadURL(this.state.tabData.surveyExternalId)
            } else {
                this.props.setSectionDownloadLink(this.state.tabData.sectionTemplateExternalId);
            }

        } else {
            if (this.state.tabData.surveyExternalId) {
                this.props.setSurveyDownloadLink(this.state.tabData.surveyExternalId);
            } else {
                this.props.setSectionDownloadLink(this.state.tabData.sectionTemplateExternalId)
            }
        }

    }
    handleUpload = (event) => {
        this.props.preloading(true);
        event.preventDefault();
        const { caseData } = this.props;
        const { tabData } = this.state
        const file = event.target.files[0];
        const requestUpload = sectionDetailsUpload(tabData, caseData, file, tabData.sectionType);
        if (isDataSection(tabData) || isFinancialSection(tabData) || isVideoKYC(tabData)) {
            this.props.sectionUpload(requestUpload, this.props.caseData.data.computedReportId);
        }
        // if section type is null / predefined / international
        else if (!tabData.sectionType || isPredefined(tabData) || isInternational(tabData)) {
            this.props.predefinedSectionUpload(requestUpload, this.props.caseData.data.computedReportId)
        }
        event.target.value = null;
    }

    handleEdit = () => {
        this.props.preloading(true);
        if(this.state.tabData.sectionTags !== null && EXECUTIVE_SUMMARY.includes(this.state.tabData.sectionTags[0])){
            this.props.fetchcaseExecutiveSummaryDetails(this.props.caseData.data.computedReportId,this.state.tabData.computedSectionId,this.state.tabData.sectionTags[0]);
        }
        else if(this.state.tabData.sectionTags !== null && FERRERO_KPI.includes(this.state.tabData.sectionTags[0]) ){
            this.props.fetchferreroKpiDetails(this.props.caseData.data.computedReportId,this.state.tabData.computedSectionId,this.state.tabData.sectionTags[0]);
        }
        else if(this.state.tabData.sectionTags !== null && SCORECARD_RATIONAL.includes(this.state.tabData.sectionTags[0])) {
            this.props.fetchcaseScorecardRationalDetails(this.props.caseData.data.computedReportId,this.state.tabData.computedSectionId);
        }
        else {
            this.props.fetchCaseScorecardDetails(this.state.tabData.computedSectionId);
        }
    }

    handleDeletePredefined = () => {
        this.handleModalToggle();
        this.setState({
            body: <div>
                Are You Sure You Want to delete this section?
                 <br />
                <Button color="success" className="ml-1 mt-5" onClick={this.handleDelete}>OK</Button>
                <Button color="danger" className="mt-5 ml-1" onClick={this.handleModalToggle}>Cancel</Button>
            </div>
        })
    }
    handleDeleteMultipleSection = () => {
        this.handleModalToggle();
        this.setState({
          
            body: <div>
                Are You Sure You Want to delete all these sections?
                 <br />
                <Button color="success" className="ml-1 mt-5" onClick={this.handleMultipleDelete}>OK</Button>
                <Button color="danger" className="mt-5 ml-1" onClick={this.handleModalToggle}>Cancel</Button>
            </div>
        })
    }
    handleMultipleDelete = () => {
        const { predefinedSectionDeleteList, dataSectionDeleteList, multipleSectionDeleteList } = this.state;
        const { caseData, deleteMultipleSections, preloading } = this.props;
    
        preloading(true);
    
        const updatedMultipleSectionDeleteList = { ...multipleSectionDeleteList };
    
        if (predefinedSectionDeleteList.length > 0) {
            updatedMultipleSectionDeleteList["predefinedSectionDeleteList"] = predefinedSectionDeleteList;
        }
        if (dataSectionDeleteList.length > 0) {
            updatedMultipleSectionDeleteList["dataSectionDeleteList"] = dataSectionDeleteList;
        }
    
        this.setState({ multipleSectionDeleteList: updatedMultipleSectionDeleteList }, () => {
            deleteMultipleSections(caseData.data.computedReportId, updatedMultipleSectionDeleteList);
            this.handleModalToggle();
        });
    }    
    handleDelete = () => {
        this.props.preloading(true);
        const { tabData } = this.state
        const { caseData, deleteDataSections, deletePredefinedSections } = this.props;
        if (isPredefined(tabData) || isInternational(tabData)) {
            deletePredefinedSections(caseData.data.computedReportId, tabData.computedSectionId)
            const Index=this.state.predefinedSectionDeleteList.indexOf(tabData.computedSectionId)
            if(Index>=0){
                this.state.predefinedSectionDeleteList.splice(Index, 1); }
        } else if(!tabData.sectionType) {
            deletePredefinedSections(caseData.data.computedReportId, tabData.computedSectionId)
            const Index=this.state.predefinedSectionDeleteList.indexOf(tabData.computedSectionId)
            if(Index>=0){
                this.state.predefinedSectionDeleteList.splice(Index, 1); }
        } else {
            deleteDataSections(caseData.data.computedReportId, tabData.computedSectionId) 
            const Index=this.state.dataSectionDeleteList.indexOf(tabData.computedSectionId)
            if(Index>=0){
                this.state.dataSectionDeleteList.splice(Index, 1); }
        }

        this.showbuttondelete()
        this.handleModalToggle()
    }
    handleAssignCorrespondent = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            corporateModalBody: <div>
                <AssignToCorrespondent
                    toggle={this.toggleCorporateModal}
                    sectionTemplateId={this.state.tabData.sectionTemplateId}
                    taskId={this.state.tabData.taskId}
                    computedReportId={this.props.caseData.data.computedReportId}
                />
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Assign To a Correspondent'
        }))
    }
    handleCommentCallback = () => {
        this.props.commentReadStatus(commentReadCountRequestBody(this.state.tabData.taskId));
    }
    handleComments = () => {
        this.setState(prevState => ({
            corporateModalBody: <div>
                <CommentSection
                    toggle={this.toggleCorporateModal}
                    taskId={this.state.tabData.taskId}
                    commentSectionCallback={this.handleCommentCallback}
                />
            </div>,
            modalType: "MODAL_TYPE_FORM",
            modalTitle: 'Comments',
            showCorporateModal: !prevState.showCorporateModal,
        }))
    }
    handleReorder = (param) => {
        this.props.preloading(true);
        let newOrder = changeOrder(param)
        this.props.reorderSections(this.props.caseData.data.computedReportId, newOrder)
    }

    handleSectionCreditLimitToggle = ()=>{
        this.setState({
            showCreditLimitEditModel: false,
        })
        window.location.reload()
    }

    handleRecalculateCreditLimit = (formData)=>{
        if(formData){
            this.props.recalculatecreditLimitAtSection(formData)
            this.setState({
                 showCreditLimitEditModel: false,
            })
            this.props.preloading(true)
        }
        else{
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>Change fields to calculate
                </div>)
        }
    }

    handleSaveCreditLimit = (recalculatedModelData,defaultModelData)=>{
        if(recalculatedModelData){
            this.props.saveCreditLimitModelAtSection(recalculatedModelData)
        }
        else{
            this.props.saveCreditLimitModelAtSection(defaultModelData)
        }
        toast.success(
            <div>
                <i className="fa fa-exclamation-triangle"></i>Saved request sended !
            </div>)
        this.setState({
            showCreditLimitEditModel: false,
        })
    }

    closeImageUploadModel=(flag)=>{
        if(flag){
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Image Upload Request Sended
                </div>
            );
        }
        this.setState({
            showImageUploadModel:false
        })
    }

    render() { 
        const { caseData } = this.props;
        let deleteButton
        let meetButton
        let reviewButton
        let assignTo
        let appButton
        let rejButton
        let comment
        if (!isSystemDefined(this.state.tabData)) {
            deleteButton = <Button outline color="primary" title="Delete Section" id="delete" onClick={this.handleDeletePredefined} disabled={hasCompleted(caseData) || isAssigned(this.state.tabData)}>
                <i className="fa fa-trash-o"></i>
            </Button>
        }

        if (isVideoKYC(this.state.tabData)){
            meetButton = <Button outline color="primary" title="Schedule meet"  onClick={this.handleMeet}>
            <i className="fa fa-video-camera"></i>
        </Button>            
        }        

        if (!isSystemDefined(this.state.tabData) && !isPredefined(this.state.tabData) && !isInternational(this.state.tabData)) {
            assignTo = <p>
                <strong>Assigned To:&nbsp;</strong>
                <a 
                    className={`pointer ${hasCompleted(caseData) || isApproved(this.state.tabData) ? "pointer-events-none" : ""}`} 
                    href="javascript:void(0)" 
                    onClick={this.handleAssignCorrespondent}>
                    {this.state.tabData && this.state.tabData.correspondentName ? this.state.tabData.correspondentName : 'NONE'}
                    {this.state.tabData && this.state.tabData.correspondentEntityName ? " (" + this.state.tabData.correspondentEntityName + ")" : ""}
                </a>
            </p>
            appButton = <Button outline color="primary" title="Approve" onClick={this.handleApprove} disabled={hasCompleted(caseData) || isApproved(this.state.tabData)}>
                <i className="fa fa-thumbs-o-up"></i>
            </Button>
            rejButton = <Button outline color="primary" title="Reject" onClick={this.handleReject} disabled={hasCompleted(caseData) || isRejected(this.state.tabData)}>
                <i className="fa fa-thumbs-o-down"></i>
            </Button>

            comment = <Button outline color="primary" title="Comments" onClick={this.handleComments} disabled={hasCompleted(caseData)}>
                <Badge color="danger" className="position-absolute notification-count">{this.state.readstatus}</Badge>
                <i className="fa fa-wechat"></i>
            </Button>
        }
        let tabs = [];
        if (this.state.tabData) {
            if (Object.keys(this.state.tabData).length > 0) {
                if (Object.keys(this.props.sections).length > 0) {
                    tabs = <SectionRearrange sectionData={this.props.sections.data} tabData={this.state.tabData} handleToggle={this.handleToggle} reorder={this.handleReorder} handleCheckbox={this.handleCheckbox} isDragDisabled={hasCompleted(caseData)} />/* this.props.sections.data.map(p => {
                        return (
                            <NavItem key={p.computedSectionId} className='tabs-style'>
                                <NavLink key={p.computedSectionId}
                                    className={classnames({ active: this.state.tabData.computedSectionId === p.computedSectionId })}
                                    onClick={(e) => this.handleToggle(e, p.computedSectionId)}
                                >
                                    <i className={sectionStatusIconClass(p.taskStatus)} title={p.taskStatus}></i>
                                    &nbsp; {p.displayName}
                                </NavLink>
                            </NavItem>
                        )
                    }) */
                }
            }
        }
        return (
            <Card>
                <CardBody className="p-2">
                    <div className="row mb-4">
                        <div className="col-6">
                        <span className="header-blue d-block p-4 text-primary font-weight-bold">Sections
                        <div className="multiple-delete-section">
                        <Button className="mx-2" size="sm" outline color="primary" title="Add" id="add" onClick={this.handleAdd} disabled={hasCompleted(caseData)}>
                         <i className="icon-plus"></i>Add
                      </Button>
                     {this.state.showDeleteButton ?
               <Button className="delete-button" outline color="primary" title="Delete multiple Section" id="delete" onClick={this.handleDeleteMultipleSection} disabled={hasCompleted(caseData) || isAssigned(this.state.tabData)}>
            <i className="fa fa-trash-o"></i>
           </Button>:null}
                   </div>
                 </span>
                            <Nav tabs vertical className="case-sections">
                                <NavItem className='tabs-style'>
                                    <Nav className="case-sections-list flex-column flex-nowrap">
                                        {tabs}
                                    </Nav>
                                </NavItem>

                                {/* {this.state.tabs} */}
                                
                            </Nav>
                        </div>
                        <div className="col-18">
                            <Row>
                                <div className="col d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        {this.state.tabContent}
                                    </div>
                                    <div>
                                        <ButtonGroup>
                                            {meetButton}
                                            {reviewButton}
                                            {comment}
                                            {this.state.imageUploadButton}
                                            {this.state.downloadAction}
                                            {this.state.uploadAction}
                                            {this.state.editCaseScorecardButton}
                                            {this.state.editSectionButton}
                                            {appButton}
                                            {rejButton}
                                            {deleteButton}
                                        </ButtonGroup>
                                    </div>
                                </div>
                            </Row>
                            <TabContent className="mt-2" activeTab={this.props.activeTab.sectionTemplateId}>
                                {assignTo}
                                {this.state.tabContent}
                                {this.state.noPdfMessage}
                                {this.state.pdfFile}
                            </TabContent>

                        </div>
                        <CasesSectionModal />
                    </div>
                </CardBody>
                <Modal show={this.state.showModal} className={this.state.modalClass} modalClosed={this.handleModalToggle} >
                    <strong className="text-danger">{this.state.warning}</strong>
                    {this.state.body}

                </Modal>
                <CorporateModal toShow={this.state.showCorporateModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.corporateModalBody}
                    title={this.state.modalTitle} />
                <Modal show={this.state.showSectionEditModal}>
                    <AutomatedRevenueForm
                        handleSectionEditToggle={this.handleSectionEditToggle}
                        createRevenuRequestBody={this.createRevenuRequestBody}/>
                    </Modal>
                <Modal show={this.state.showBenchmarkModal}>
                    <AutomatedBenchmarkForm showBenchmarkModal={this.state.showBenchmarkModal}
                        handleSectionEditToggle={this.handleSectionEditToggle}
                        createBencmarkRequestBody={this.createBencmarkRequestBody}
                    />   
                </Modal>
                <Modal show={this.state.showCreditLimitEditModel}>
                <CreditLimitEditSection
                handleSectionCreditLimitToggle={this.handleSectionCreditLimitToggle}
                handleSaveCreditLimit={this.handleSaveCreditLimit}
                handleRecalculateCreditLimit={this.handleRecalculateCreditLimit}
                />    
                </Modal>
            </Card>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    sections: state.section.sectionList,
    activeTab: state.section.activeTab,
    dropdown: state.section.dropdown,
    modal: state.section.modal,
    downloadUrl: state.section.downloadUrl,
    caseData: state.section.caseDetails,
    sectionPdfFile: state.section.showPdf,

    // response for `addPredefinedSections`
    addedPredefSections: state.section.addedPredefSections,

    // resposne of `predefinedSectionUpload`
    uploadPredefinedModal: state.section.uploadPredefinedModal,

    // response for `deletePredefinedSections`
    deletedPredefinedSectionData: state.section.deletedPredefinedSectionData,
    deletedMultipleSectionData: state.section.deletedMultipleSectionData,
    caseScorecardDetails: state.section.caseScorecardDetails,
    caseScorecardDetailsError: state.section.caseScorecardDetailsError,
    recalculatedScore: state.section.caseScorecardRecalculate,
    caseScorecardRecalculateError: state.section.caseScorecardRecalculateError,
    // response of `saveCaseScorecard`
    caseScorecardEdit: state.section.caseScorecardEdit,
    caseScorecardEditError: state.section.caseScorecardEditError,

    // response of `sectionUpload`
    uploadModal: state.section.uploadModal,
    uploadModalError: state.section.uploadModalError,

    //response of `Image section upload`
    uploadImageResponse: state.section.uploadImageResponse,
    uploadImageResponseError: state.section.uploadImageResponseError,

    // response for `addDataSections`
    addedDataSections: state.section.addedDataSections,

    assigned: state.section.assigned,
    taskStatus: state.section.taskStatus,

    // response for `deleteDataSections`
    deletedDataSection: state.section.deletedDataSection,
    readCommentStatus: state.commonReducer.readCommentStatus,

    // response for credit limit
    initialValues: state.creditLimitEditSection.creditLimitModelParams,
    recalculatedValues: state.creditLimitEditSection.recalculatecreditLimitResponse,
    ferreroKpiDetails : state.section.ferreroKpiDetails,
    systemDefineSectionSuccessStatus : state.section.caseExecutiveSummaryDetails,
    systemDefineSectionFailureStatus : state.section.caseExecutiveSummaryDetailsError,
    caseScorecardRationalDetailssStatus : state.section.caseScorecardRationalDetails,
    caseScorecardRationalDetailsErrorStatus : state.section.caseScorecardRationalDetailsError,
    revenuCalculationParams : state.automatedRevenueData.revenuCalculationParams,
    creditLimitModelParams: state.creditLimitEditSection.creditLimitModelParams,
    revenuCalculationParams: state.creditLimitEditSection.recalculatecreditLimitResponse,
    revenuCalculationResponse: state.automatedRevenueData.revenuCalculationResponse,
    benchmarkCalculationParams : state.automatedBenchmarkData.benchmarkCalculationParams,
    benchmarkCalculationResponse: state.automatedBenchmarkData.benchmarkCalculationResponse,
    scoreBreakUpDetailsStatus: state.section.scoreBreakUpDetails,
    scoreBreakUpDetailsErrorStatus: state.section.scoreBreakUpDetailsError,
    scoreSummaryDetailsStatus: state.section.scoreSummaryDetails,
    scoreSummaryDetailsErrorStatus: state.section.scoreSummaryDetailsError,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    showSectionPdf: (id) => { dispatch(sectionAction.showSectionPdf(id)) },
    setSectionDownloadLink: (id) => { dispatch(sectionAction.setSectionDownloadURL(id)) },
    setDataSurveyDownloadLink: (id) => { dispatch(sectionAction.setDataSurveyDownloadURL(id)) },
    setFinancialSurveyDownloadLink: (id) => { dispatch(sectionAction.setFinancialSurveyDownloadLink(id)) },
    setSurveyDownloadLink: (id) => { dispatch(sectionAction.setSurveyDownloadURL(id)) },
    setpredefinedSectionDownloadURL: (id) => { dispatch(sectionAction.setpredefinedSectionDownloadURL(id)) },
    predefinedSectionUpload: (requestBody, id) => { dispatch(sectionAction.predefinedSectionUpload(requestBody, id)) },
    sectionUpload: (requestBody, id) => { dispatch(sectionAction.sectionUpload(requestBody, id)) },
    addPredefinedSections: (id, List) => { dispatch(sectionAction.addPredefinedSections(id, List)) },
    deletePredefinedSections: (computedreportid, computedsectionid) => { dispatch(sectionAction.deletePredefinedSections(computedreportid, computedsectionid)) },
    deleteMultipleSections: (computedreportid, multipleSectionDeleteList) => { dispatch(sectionAction.deleteMultipleSections(computedreportid, multipleSectionDeleteList)) },
    fetchCaseScorecardDetails: (id) => { dispatch(sectionAction.fetchCaseScorecardDetails(id)) },
    recalculateScore: (data) => { dispatch(sectionAction.recalculateScore(data)) },
    uploadMultipleImages: (data, id) => { dispatch(sectionAction.uploadMultipleImages(data, id)) },
    saveCaseScorecard: (data) => { dispatch(sectionAction.saveCaseScorecard(data)) },
    setActiveTab: (data) => { dispatch(sectionAction.setActiveTab(data)) },
    deleteDataSections: (computedreportid, computedsectionid) => { dispatch(sectionAction.deleteDataSections(computedreportid, computedsectionid)) },
    approveSection: (taskId, computedreportid) => { dispatch(sectionAction.approveSection(taskId, computedreportid)) },
    rejectSection: (taskId, computedreportid, reqBody) => { dispatch(sectionAction.rejectSection(taskId, computedreportid, reqBody)) },
    downloadSubmittedTask: (data) => { dispatch(sectionAction.downloadSubmittedTask(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    getAllSections: (data) => { dispatch(sectionAction.getAllSections(data)); },
    commentReadStatus: (data) => { dispatch(commentReadStatus(data)) },
    reorderSections: (id, body) => { dispatch(sectionAction.reorderSections(id, body)) },
    fetchcaseExecutiveSummaryDetails: (computedReportId,computedSectionId,sectionaTag) => { dispatch(sectionAction.fetchcaseExecutiveSummaryDetails(computedReportId,computedSectionId,sectionaTag)) },
    fetchcaseScorecardRationalDetails: (computedReportId,computedSectionId) => { dispatch(sectionAction.fetchcaseScorecardRationalDetails(computedReportId,computedSectionId)) },
    fetchScoreBreakUpDetails: (computedReportId,sectiontag) => { dispatch(sectionAction.fetchScoreBreakUpDetails(computedReportId,sectiontag)) },
    fetchScoreSummaryDetails: (computedReportId,computedSectionId) => { dispatch(sectionAction.fetchScoreSummaryDetails(computedReportId,computedSectionId)) },
    fetchferreroKpiDetails: (computedReportId,computedSectionId,sectionaTag) => { dispatch(sectionAction.fetchferreroKpiDetails(computedReportId,computedSectionId,sectionaTag)) },
    fetchCalculationParameterRequest: (data) => { dispatch(fetchCalculationParameterRequest(data)) },
    getCreditLimitModelAtSectionData: (data) => { dispatch(getCreditLimitModelAtSectionData(data)) },
    recalculatecreditLimitAtSection: (data) => { dispatch(recalculatecreditLimitAtSection(data)) },
    saveCreditLimitModelAtSection: (data) => { dispatch(saveCreditLimitModelAtSection(data)) },
    fetchCalculateRevenueRequest: (caseId, formData) => { dispatch(fetchCalculateRevenueRequest({caseId, formData})) },
    fetchBenchmarkCalculationParameterRequest: (caseId) => { dispatch(fetchBenchmarkCalculationParameterRequest({caseId})) },
    fetchCalculateBenchmarkRequest: (caseId, formData) => { dispatch(fetchCalculateBenchmarkRequest({caseId, formData})) }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps)(ViewSections);
